(ns ycweb.components.wrapper
   (:require
      [rum.core :as rum]
      [ycweb.components.forms :as forms]
      [ycweb.app.pos.menu :as menu]
      [ycweb.components.buttons :as buttons]
      [ycweb.components.toaster :as toaster]
      [ycweb.components.header :as header]))

(rum/defc wrapper [app-atom heading {:keys [modal-fn steps step]} body foot-note call-to-action]
  [:div.page-body
   (header/header app-atom heading {})
   (header/menu-overlay (rum/cursor app-atom :menu))
   (header/menu app-atom (menu/select-menus app-atom))
   (into
     [:div.page-body__main-content
      (when modal-fn
        [:nav.section.button-bar
         (buttons/button
           " Options"
           #(modal-fn app-atom)
           {:icon-right :dots-menu-horizontal :muted true :text-default true})])

      (when steps
        [:div.section
         (forms/progress-steps
           (forms/progress-step steps step))])]
     body)

   (toaster/loading-overlay app-atom :pos/printing)

   (into
     [:aside.page-body__footer]
     foot-note)
   call-to-action])